import type { PermissionKey, ResolvedPermissions } from '../domain/permission'

const checkPermission = (permissions: ResolvedPermissions, key: PermissionKey): boolean =>
	permissions[key]

export { checkPermission }
